import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './DashboardIcons';
import { SectionCard, EmptyState } from './TodaySchedule';

const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const diffMin = Math.floor((Date.now() - d.getTime()) / 60000);
  if (diffMin < 1) return 'الآن';
  if (diffMin < 60) return `منذ ${new Intl.NumberFormat('ar-EG').format(diffMin)} دقيقة`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `منذ ${new Intl.NumberFormat('ar-EG').format(diffH)} ساعة`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 30) return `منذ ${new Intl.NumberFormat('ar-EG').format(diffD)} يوم`;
  return new Intl.DateTimeFormat('ar-SA-u-ca-gregory', { day: 'numeric', month: 'short' }).format(d);
};

const iconFor = (action = '') => {
  if (action.includes('لاعب')) return 'users';
  if (action.includes('مباراة')) return 'calendar';
  if (action.includes('بطولة')) return 'trophy';
  if (action.includes('فريق')) return 'userGroup';
  if (action.includes('إعداد')) return 'cog';
  return 'document';
};

export const RecentActivity = ({ activities }) => (
  <SectionCard
    title="آخر النشاطات"
    icon="clock"
    testId="recent-activity"
    action={<Link to="/activity-log" className="text-xs font-semibold text-teal-700 hover:text-teal-800" data-testid="activity-view-all">السجل الكامل</Link>}
  >
    {(!activities || activities.length === 0) ? (
      <EmptyState icon="clock" text="لا يوجد نشاط مسجل بعد" testId="activity-empty" />
    ) : (
      <ul className="space-y-3">
        {activities.slice(0, 5).map((a, i) => (
          <li key={a.id || i} className="flex items-center gap-3" data-testid="activity-item">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500">
              <Icon name={iconFor(a.action)} className="w-4 h-4" />
            </span>
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm text-slate-800">{a.action || a.description || 'عملية'}</div>
              <div className="text-xs text-slate-400">
                {[a.user_name, timeAgo(a.created_at || a.timestamp)].filter(Boolean).join(' • ')}
              </div>
            </div>
          </li>
        ))}
      </ul>
    )}
  </SectionCard>
);

export default RecentActivity;
